import { render } from "./BasicCheckbox.vue?vue&type=template&id=6b3283ee&scoped=true"
import script from "./BasicCheckbox.vue?vue&type=script&lang=js"
export * from "./BasicCheckbox.vue?vue&type=script&lang=js"

import "./BasicCheckbox.vue?vue&type=style&index=0&id=6b3283ee&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src17432379/src/orprio-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b3283ee"]])

export default __exports__